import { useEffect } from 'react'
import { createLogger } from '../../../app/logger'
import useAppDispatch from '../../../hooks/useAppDispatch'
import { setOnline } from '../networkSlice'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'NetworkDetector'
})

const NetworkDetector = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handleOnlineEvent = (e: Event) => {
      logger.info('handle online event', e)

      dispatch(setOnline(true))
    }

    const handleOfflineEvent = (e: Event) => {
      logger.info('handle offline event', e)

      dispatch(setOnline(false))
    }

    dispatch(setOnline(navigator.onLine))

    window.addEventListener('online', handleOnlineEvent)
    window.addEventListener('offline', handleOfflineEvent)

    return () => {
      window.removeEventListener('online', handleOnlineEvent)
      window.removeEventListener('offline', handleOfflineEvent)
    }
  }, [dispatch])

  return <></>
}

export default NetworkDetector
